import { useMutation, useQueryClient } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { toast } from "react-toastify";

/**
 * Grant referral coins to a specific user.
 * @param {string} userId - target user id (UUID) to credit
 */
const useGrantReferralCoins = (userId) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ amount, notes }) =>
      request({
        url: `/coin/admin/grantPillCoins`,
        method: "POST",
        data: { userId, amount, notes },
      }),
    {
      onSuccess: (res) => {
        // Backend returns HTTP 200 with { success, data, error } even on failure
        if (res?.data?.success === false) {
          toast.error(res?.data?.error || "Failed to grant referral coins");
          return;
        }
        toast.success("Referral coins granted");
        queryClient.invalidateQueries({ queryKey: ["get-user-details"] });
        queryClient.invalidateQueries({ queryKey: ["get-coin-balance"] });
      },
      onError: (error) => {
        const msg =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "Failed to grant referral coins";
        toast.error(msg);
      },
    }
  );
};

export default useGrantReferralCoins;
